var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-header"},[_c('h2',[_vm._v(_vm._s(_vm.$tf('license')))])]),_c('license-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }